import React, { Component } from "react"
import { Image, Button } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import HeadphoneImage from "../../../images/dashboard/headphones.svg"
import CheckIcon from "../../../images/dashboard/check-icon.svg"
import { showChatWidget } from "../../../v1/helpers/userHelper"

class TechAdvisorCard extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { t } = this.props
    return (
      <div className="tech-advisor-card" onClick={showChatWidget}>
        <div className="tech-advisor-card-content">
          <p className="tech-advisor-card-heading">{t("talkToACertifiedtechAdvisorMsg")}</p>
          <p className="tech-advisor-card-text">{t("certifiedMaitenancetechsMsg")}</p>
        </div>
        <div className="tech-advisor-card-images">
          <Image className="headphones-image" src={HeadphoneImage} />
          <Image className="headphone-checkIcon" src={CheckIcon} />
        </div>
      </div>
    )
  }
}

export default withTranslation("justForYouCards")(TechAdvisorCard)
